
$(document).ready ->
  $menuLeft = $('.pushmenu-left')
  $nav_list = $('#toggleMobileNav')
  $nav_list.click ->
    $(this).toggleClass 'active'
    $('.pushmenu-push').toggleClass 'pushmenu-push-toright'
    $menuLeft.toggleClass 'pushmenu-open'
    return
  return

$ ->
  $('.togglemobilenav').click (e) ->
    $('.hamburger-icon').toggleClass 'open'
    e.preventDefault()


// WEBPACK FOOTER //
// ./Components/offcanvas.coffee